import { Trash2 } from "lucide-react";

const euro = (v) => `${Number(v || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const isLease = (f) => (f?.provider || "").toLowerCase() === "mutualease";

export const FinancingBlock = ({ financing: f, priceTtc, solde, onRemove, testid = "financing-block" }) => {
  const lease = isLease(f);
  const priceDiff = f.prix_ttc > 0 && Math.abs(f.prix_ttc - priceTtc) > 1;
  const stale = !lease && f.montant > 0 && Math.abs(f.montant - solde) > 1;
  return (
    <div className="rounded-md border border-[#9E7B41]/40 bg-[#9E7B41]/5 px-2.5 py-2 text-xs space-y-0.5" data-testid={testid}>
      <div className="flex items-center justify-between gap-2">
        <span className="font-semibold">{f.solution || "Financement"}{f.provider ? ` (${f.provider})` : ""}</span>
        {onRemove && <button type="button" className="text-muted-foreground hover:text-destructive" onClick={onRemove} data-testid="financing-remove"><Trash2 className="w-3.5 h-3.5" /></button>}
      </div>
      {lease && f.premier_versement > 0 && <div data-testid={`${testid}-first`}>1er loyer majoré : <span className="font-mono">{euro(f.premier_versement)}</span></div>}
      <div className="font-mono" data-testid={`${testid}-monthly`}>
        {lease ? "Loyer mensuel : " : ""}{f.duree} × {euro(f.mensualite)} / mois{f.taeg != null ? ` · TAEG ${(f.taeg * 100).toFixed(2).replace(".", ",")} %` : ""}
      </div>
      {!lease && f.premier_versement > 0 && <div className="text-muted-foreground" data-testid={`${testid}-first`}>1er versement : {euro(f.premier_versement)}</div>}
      {f.montant > 0 && <div className="text-muted-foreground">Montant financé : {euro(f.montant)}</div>}
      {f.cout_total != null && <div className="text-muted-foreground" data-testid={`${testid}-cost`}>Coût total : {euro(f.cout_total)}</div>}
      {priceDiff && <div className="text-destructive font-medium" data-testid={`${testid}-price-diff`}>Le prix utilisé pour le financement diffère du devis ({euro(f.prix_ttc)}).</div>}
      {stale && <div className="text-destructive font-medium" data-testid={`${testid}-stale`}>Le solde a changé : refaites la simulation avec « Voir les financements ».</div>}
    </div>
  );
};
